import React from 'react';

type Props = {
  testID?: string;
  num: string;
};

export const CircleBadge: React.FC<Props> = ({ num, testID = 'CircleBadge' }) => {
  return (
    <div
      data-testid={testID}
      className="w-8 h-8 rounded-full bg-dark text-white flex justify-center items-center font-semibold text-xl"
    >
      {num}
    </div>
  );
};
